module.exports = __webpack_public_path__ + "img/6.86d14f81.png";